import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import './i18next';
import App from './App';
import { SnackbarUtilsConfigurator } from './utils/SnackbarUtils';
import { setupConsoleSilencing } from './utils/setupConsoleSilencing';

setupConsoleSilencing();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <SnackbarUtilsConfigurator />
      <App />
    </SnackbarProvider>
  </React.StrictMode>
);
